import React, { useEffect } from "react";

const NotFoundPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <h1>Opps this page is not found!</h1>
    </>
  );
};

export default NotFoundPage;
